import * as types from '../mutation-types'
import { api } from '@/modules/api'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'
import { pathOr } from 'ramda'

const state = {
  allAttendee: [],
  totalPagesAttendee: null,
  totalItemsAttendee: null,
  regularInvitations: null,
  allAttendeeStatusesCount: null,
  regularAttendeeStatusesCount: null,
  vipAttendeeStatusesCount: null,
  allCryptoTraders: null,
  totalPagesAllCryptoTraders: null,
  totalItemsAllCryptoTraders: null,
  cryptoTraderPackages: null
}

const getters = {
  getAllAttendee: state => state.allAttendee,
  getTotalPagesAllAttendee: state => state.totalPagesAttendee,
  getTotalItemsAllAttendee: state => state.totalItemsAttendee,
  getRegularInvitations: state => state.regularInvitations,
  getAllAttendeeStatusesCount: state => state.allAttendeeStatusesCount,
  getCryptoTradersList: state => state.allCryptoTraders,
  getTotalPagesAllCryptoTraders: state => state.totalPagesAllCryptoTraders,
  getTotalItemsAllCryptoTraders: state => state.totalItemsAllCryptoTraders,
  getCryptoTraderPackages: state => state.cryptoTraderPackages
}

const actions = {
  async fetchAllAttendee ({ commit, dispatch }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.getAllAttendee(payload))
      commit(types.SET_ALL_ATTENDEE, data)
      return data
    } catch (err) {
      dispatch('showResultErrorMessage', 'Failed to fetch list of attendee')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchAllAttendeeStatusesCount ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.getAllStatusesCount())
      commit(types.SET_ALL_ATTENDEE_STATUSES_COUNT, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get statuses count')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchRegularAttendeeStatusesCount ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.getRegularAttendeeStatusesCount())
      commit(types.SET_REGULAR_ATTENDEE_STATUSES_COUNT, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get statuses count')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVipAttendeeStatusesCount ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.getVipAttendeeStatusesCount())
      commit(types.SET_VIP_ATTENDEE_STATUSES_COUNT, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to get statuses count')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resendConfirmationEmail ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.resendConfirmationEmail(), payload)
      this.dispatch('showResultSuccessMessage', 'Confirmation emails were sent')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Confirmation emails were not sent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async requestForPhoto ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.requestForPhoto(), payload)
      this.dispatch('showResultSuccessMessage', 'Request for photo emails were sent')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Request for photo emails were not sent')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async rejectAttendee ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.attendee.rejectAttendee(id))
      this.dispatch('showResultSuccessMessage', 'Reject status was set')
    } catch (err) {
      this.dispatch('showResultSuccessMessage', 'Reject status wasn\'t set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setActivitiesRegular ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setActivitiesRegular(), payload)
      this.dispatch('showResultSuccessMessage', 'Activities was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Activities was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendReminders ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.sendReminders(), payload)
      this.dispatch('showResultSuccessMessage', 'Send Reminders')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Reminders was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setActivitiesVip ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setActivitiesVip(), payload)
      this.dispatch('showResultSuccessMessage', 'Activities was set')
    } catch (err) {
      console.log(err, 'Error')
      this.dispatch('showResultErrorMessage', pathOr('Activities was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async unsetActivitiesRegular ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.unsetActivitiesRegular(), payload)
      this.dispatch('showResultSuccessMessage', 'Activities was unset')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Activities was not unset', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async unsetActivitiesVip ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.unsetActivitiesVip(), payload)
      this.dispatch('showResultSuccessMessage', 'Activities was unset')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Activities was not unset', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setStatus ({ commit }, data) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      if (data.status === 'RequestForPayment') {
        const setStatus = data.status
        const attendeeList = {}
        attendeeList.ids = data.ids
        await this.$axios.patch(api.massAttendeeActions[setStatus](), attendeeList)
        this.dispatch('showResultSuccessMessage', 'Status was set')
      } else {
        await this.$axios.patch(api.massAttendeeActions.setStatus(), data)
        this.dispatch('showResultSuccessMessage', 'Status was set')
      }
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Status was not set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setInfo ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setInfo(), payload)
      this.dispatch('showResultSuccessMessage', 'Info was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Info was not set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setMessageLimitRegulars ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setMessageLimitRegulars(), payload)
      this.dispatch('showResultSuccessMessage', 'Message limit was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Message limit was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setMessageLimitVips ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setMessageLimitVips(), payload)
      this.dispatch('showResultSuccessMessage', 'Message limit was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Message limit was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setIndustry ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setIndustry(), payload)
      this.dispatch('showResultSuccessMessage', 'Industry was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Industry was not set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setTypeRegulars ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setTypeRegulars(), payload)
      this.dispatch('showResultSuccessMessage', 'Type was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Type was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setTypeVips ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.setTypeVips(), payload)
      this.dispatch('showResultSuccessMessage', 'Type was set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', pathOr('Type was not set', ['response', 'data', 'Message'], err))
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async killerFeatureTagSearchHide ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.killerFeatureTagSearchHide(), payload)
      this.dispatch('showResultSuccessMessage', 'Settings were set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Settings were not set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async hideEnvelope ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.hideEnvelope(), payload)
      this.dispatch('showResultSuccessMessage', 'Settings were set')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Settings were not set')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async downloadAttendeeExcel ({ commit }, { exportPaths, getParams }) {
    try {
      const { data } = await this.$axios({
        method: 'post',
        url: api.attendee.getExcelAttandee(getParams),
        responseType: 'arraybuffer',
        data: exportPaths
      })
      saveFileFromBase64(data, 'Attendee', 'xlsx')
    } catch (err) {
      throw err
    }
  },
  async downloadAttendeesExcelAll () {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.attendee.getExcelAttandeeAll(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Attendee', 'xlsx')
    } catch (err) {
      throw err
    }
  },
  async downloadCryptoTradersExcel () {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.attendee.getCryptoTradersExcel(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Attendee', 'xlsx')
    } catch (err) {
      throw err
    }
  },
  async fetchRegularInvitations ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.fetchRegularInvitations(payload))
      commit(types.SET_REGULAR_INVITATIONS, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Regular invitations were not loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async changePackageOfAttendee ({ commit }, payload) {
    try {
      const response = await this.$axios.put(api.attendee.changePackage(), payload)
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Package wasn\'t changed')
      throw err
    }
  },
  async assignPackageToPendingPackageAttendee ({ commit }, payload) {
    try {
      const response = await this.$axios.patch(api.attendee.changePackage(), payload)
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Package wasn\'t assigned')
      throw err
    }
  },
  async fetchCryptoTradersList ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.attendee.fetchCryptoTraders(payload))
      commit(types.SET_CRYPTO_TRADERS_LIST, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Crypto traders were not loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchCryptoTraderPackages ({ commit }, attendeeEmail) {
    try {
      const { data } = await this.$axios.get(api.attendee.getCryptoPackages(attendeeEmail))
      commit(types.SET_CRYPTO_TRADER_PACKAGES, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to fetch packages')
      throw err
    }
  },
  async updateCryptoTrader ({ commit }, payload) {
    try {
      const response = await this.$axios.put(api.attendee.updateTrader(), payload)
      this.dispatch('showResultSuccessMessage', 'Crypto trader was successfully updated')
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update crypto trader')
      throw err
    }
  },
  async updateCryptoTraderPackage ({ commit }, payload) {
    try {
      const response = await this.$axios.put(api.attendee.updateTraderPackage(), payload)
      this.dispatch('showResultSuccessMessage', 'Crypto trader package was successfully updated')
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update crypto trader package')
      throw err
    }
  },
  async assignCryptoTraderPackage ({ commit }, payload) {
    try {
      const response = await this.$axios.put(api.attendee.assignTraderPackage(), payload)
      this.dispatch('showResultSuccessMessage', 'Crypto trader package was successfully updated')
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update crypto trader package')
      throw err
    }
  },
  async updateAttendeeSubscription ({ commit }, payload) {
    try {
      const response = await this.$axios.post(api.attendee.updateSubscription(), payload)
      this.dispatch('showResultSuccessMessage', 'Newsletter subscription was successfully updated')
      return response
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to update newsletter subscription')
      throw err
    }
  },
  async addToBlacklist ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.massAttendeeActions.addToBlacklist(), payload)
      this.dispatch('showResultSuccessMessage', 'Added to blacklist')
    } catch (err) {
      this.dispatch(
        'showResultErrorMessage',
        pathOr('Not added to blacklist', ['response', 'data', 'Message'], err)
      )
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchCryptotraderInvitationLink ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.post(api.attendee.getCryptotraderToken(), payload)
      return data
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to fetch link')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_ALL_ATTENDEE] (state, { attendees, totalPages, totalItems }) {
    state.allAttendee = attendees.map(e => {
      e.imageUrl = e.image ? e.image.imageUrl : '' // hard logick on back end to prevent this
      return e
    })
    state.totalPagesAttendee = totalPages
    state.totalItemsAttendee = totalItems
  },
  [types.SET_REGULAR_INVITATIONS] (state, invitations) {
    state.regularInvitations = invitations
  },
  [types.SET_ALL_ATTENDEE_STATUSES_COUNT] (state, data) {
    state.allAttendeeStatusesCount = data.statusesCount
  },
  [types.SET_REGULAR_ATTENDEE_STATUSES_COUNT] (state, data) {
    state.regularAttendeeStatusesCount = data.statusesCount
  },
  [types.SET_VIP_ATTENDEE_STATUSES_COUNT] (state, data) {
    state.vipAttendeeStatusesCount = data.statusesCount
  },
  [types.SET_CRYPTO_TRADERS_LIST] (state, { cryptoTraders, totalPages, totalItems }) {
    state.allCryptoTraders = cryptoTraders
    state.totalPagesAllCryptoTraders = totalPages
    state.totalItemsAllCryptoTraders = totalItems
  },
  [types.SET_CRYPTO_TRADER_PACKAGES] (state, packages) {
    state.cryptoTraderPackages = packages
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attendee.js